export const DEFAULT_SMTP = {
  host: 'portaldecliente.es',
};

export const NOTIFICATION_TYPES = {
  SINGLES: 'singles',
  MULTIPLES: 'multiples',
};
